import React from 'react'
import { Link as LinkComponent } from 'react-router-dom'
import { mkWidget } from 'widgets-for-react'
import { toRelativeUrl } from '../../../helpers'
import { Link } from './types.gen'
import { ButtonProps } from './widgets/featuredContentBlock.gen'
import { LinkProps } from './widgets/linkBlock.gen'


export function jsxToWidget<a>(jsx: JSX.Element) {
  return mkWidget<a>({ run: _ => jsx })
}

export function getClassName<style>(options: { style?: style }, className: keyof style, notset: string = ''): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset)
}

export function link(
  link: Link,
  style: { classname: string },
  inner: JSX.Element | string,
  onclick?: () => void
): JSX.Element {
  return link.is_link_external || link.target === '_blank' ? (
    <a className={style.classname} target={link.target} href={link.url} onClick={onclick ? onclick : null}>
      {inner}
    </a>
  ) : (
    <LinkComponent className={style.classname} to={link.url} onClick={onclick ? onclick : null}>
      {inner}
    </LinkComponent>
  )
}

//  This function matches the url of a DrupalLink against a regex that checks if the url that we want to
//  navigat to is on the same host we are curently at, or is only a path so we can use the <Link> component
//  otherwhise, if it isnt a url on our own hostname it returns true and is external.

export const isLinkExternal = (link: string): boolean => {
  let currentUrl = window.location.host
  let pattern = RegExp(`(https?:\/\/(!?${currentUrl}/.*)|^\/.*)`, 'gm')
  const httpString = link.substr(0, 4);
  const httpsString = link.substr(0, 5);
  if(httpString == "http" || httpsString == "https"){
    let parsedLink = link.replace("https://", "");
    parsedLink = parsedLink.replace("http://","");
    parsedLink = parsedLink.replace("www.", "");
    if(parsedLink.includes("/")){
      const l = parsedLink.split("/");
      if(l.length > 0){
        parsedLink = l[0];
      }
    }
    if(currentUrl.includes(parsedLink)){
      return false;
    }else {
      return true;
    }
  }
  return !pattern.test(link)
}

// Strip a Drupal link of its domain information so we only have the path left
export const stripUrlToPath = (link: { title: string; url: string }): string => {
  let a = document.createElement('a')
  a.href = link.url
  let path = a.search? a.pathname + a.search : a.pathname
  return path[0] === '/' ? path : '/' + path // Fix stolen from  https://github.com/hoppinger/rijkzwaan-inseeds-website/commit/b2973de7bf5d3fb454a7317af97f4982ffd5ba22
}

// Create a link from an acf link that checks if it is external, and rewrites the url if needed
export const buttonWrapper = (link: { title: string; url: string }): ButtonProps<never, never> => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: '_self',
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

export const linkWrapper = (link: { title: string; url: string }): Link => ({
  kind: 'link',
  is_link_external: isLinkExternal(link.url),
  target: isLinkExternal(link.url) ? '_blank' : '_self',
  title: link.title,
  url: isLinkExternal(link.url) ? link.url : stripUrlToPath(link)
})

export const parseLinkProps = (li: { title: string; url: string; target?: LinkProps['target'] }, key: number): LinkProps => ({
  key: key.toString(),
  title: li.title,
  target:  li.target == undefined || li.target.length == 0  || li.target == '_self' ? '_self' : '_blank',
  url: isLinkExternal(li.url) ? li.url : stripUrlToPath(li)
})

export function getParameterByName(name: string): string {
  let url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) {
    return ''
  }
  if (!results[2]) {
    return ''
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function insertUrlParam(key: string, value: string): void {
  if (history.pushState) {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value)
    let newurl =
      window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString()
    window.history.pushState({ path: newurl }, '', newurl)
  }
}
export function removeUrlParams(kind: 'all' | string): void {
  if (history.pushState) {
    let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname
    if (kind !== 'all') {
      let searchParams = new URLSearchParams(window.location.search)
      searchParams.delete(kind)
      newurl = newurl + '?' + searchParams.toString()
    }

    window.history.pushState({ path: newurl }, '', newurl)
  }
}
